angular.module('jv.candidates.list.controller', [])
    .controller('jvCandidatesListController', [
        '$scope', '$rootScope', 'TemplateLoader', 'jvCandidatesService', '$window', '$q', 'jvCandidatesListFactory', '$sessionStorage','jvHireUrlService',
        function($scope, $rootScope, TemplateLoader, jvCandidatesService, $window, $q, jvCandidatesListFactory, $sessionStorage,jvHireUrlService) {
            
            $scope.flags.loading = false;
            $scope.flags.filterExpanded = true;
            //flag to do validation for selected candidate
            $scope.noCandidateSelected = false;
            
            $scope.properties = properties;
            //initialize search filters
            var initSearchFilters = function(){
                //pagination configs
                $scope.currentPage = 0;
                $scope.totalCount  = 0;
                $scope.pageSize = 0;
                $scope.search = {
                    keyword: '',
                    nameOnlySearch:true
                };
                $scope.defaultValue = 'Search Candidates';
            };
            initSearchFilters();

            //clear search related localstorage data
            delete $sessionStorage.search_guid;
            delete $sessionStorage.search_page;

            delete $sessionStorage.search_index;
            delete $sessionStorage.search_application_ids;
            delete $sessionStorage.search_total_count;

            //Return list of jobs to render in the tooltip except the first one which is already rendered.
            $scope.getCandidateJobs = function(jobList){
                return jobList.slice(1,jobList.length);
            };

            var getCandidateIndex = function(selectedCandidate){
                var index = 0;
                angular.forEach($scope.candidates,function(candidateObj,key){
                    if(candidateObj.EId ===selectedCandidate.EId){
                        index =  ($scope.pageSize*$scope.currentPage)+ (key);
                    }
                });
                return index;
            };

            //navigationListConfig for profile and search page links
            $scope.navigationListConfig = {
                actionTitle: i18n['SEARCH'],
                sortOptions: [
                    {
                        value: i18n['APPLICATIONS'],
                        id: 0,
                        action: 'applications'
                    },
                    {
                        value: i18n['PROFILES'],
                        id: 1,
                        action: 'profiles'
                    }
                ],
                selectedOption: 1
            };

            if($window.isLinkedInUnifiedSearchEnabled) {
                $scope.navigationListConfig.sortOptions.push({
                    value: 'LinkedIn',
                    id: 2,
                    action: 'linkedIn'
                })
            }

            //watch dropdown selection
            $scope.$watch('navigationListConfig.selectedOption', function(newValue, oldValue) {
                if (angular.isDefined(newValue) && newValue != -1) {
                    triggerNavigationAction($scope.navigationListConfig.sortOptions[newValue].action);
                }
            });

            //redirect to profile list page
            var goToApplicationListPage = function(){
                $window.location.href = jvHireUrlService.getCandidateListPageUrl();
            };

            //redirect to profile list page
            var goToLinkedInPage = function(){
                var url = $scope.jvUrls.jhire +'/modules/candidates/linkedin.html';
                $window.location.href = url;
            };

            //trigger navigation action dropdown
            var triggerNavigationAction = function(action){
                switch(action){
                    case 'applications':
                    goToApplicationListPage();
                    break;
                    case 'linkedIn':
                        goToLinkedInPage();
                    break;
                }
            };

             //TODO : Will be replaced with data coming from API 
            $scope.searchTypes = {
                actionTitle: " ",
                actionType: "icon",
                sortOptions: [
                    {
                        type: 'all',
                        placeholder: i18n.SEARCH_TYPE_ALL,
                        value: i18n.ALL_KEYWORD,
                        icon: 'icon icon-search'
                    },
                    {
                        type: 'name',
                        placeholder: i18n.SEARCH_TYPE_NAME,
                        value: i18n.NAME,
                        icon: 'icon icon-profile'
                    }
                ],
                selectedOption: 1
            };

            //watch dropdown selection
            $scope.$watch('searchTypes.selectedOption', function(newValue, oldValue) {
                if (angular.isDefined(newValue) && newValue != -1) {
                    triggerSearchType($scope.searchTypes.sortOptions[newValue].type, $scope.searchTypes.sortOptions[newValue]);
                }
            });
            $scope.activeSearchObject = $scope.searchTypes.sortOptions[0];
            
            var triggerSearchType = function(type,searchObject){
                $scope.search.nameOnlySearch = false;
                $scope.activeSearchObject = searchObject;
                if($scope.activeSearchObject.type==='name'){
                    $scope.search.nameOnlySearch = true;
                }
            };
            //redirect to candidate details
            $scope.goToCandidateDetail = function(candidate){
                $sessionStorage.search_guid = $scope.GUID;
                $scope.candidateIndex = getCandidateIndex(candidate);
                $sessionStorage.search_page = $scope.currentPage;
                
                $sessionStorage.search_index = $scope.candidateIndex;
                $window.location.href = jvHireUrlService.getApplicationDetailsDefaultTabUrl(candidate.latestApplicationEId);
            };

            //drop down actions config
            $scope.actionListConfig = {
                    actionTitle: i18n.ACTIONS,
                    sortOptions: [ ],
                    selectedOption: -1
            };
            
            //add actions based on the user permission
            var addActionConfigOptions = function(sortOptions) {
            	if($scope.properties.hasAccessToAddToReq) {
            		var sortOption = {
            				value: i18n['ADD_TO_REQUISITION'],
                            id: 0,
                            action: 'addToReq'	
            		}
            		sortOptions.push(sortOption);
            	}
            	if($scope.properties.hasAccessToReject) {
            		var sortOption = {
            				value: i18n['CANDIDATE_REJECT_ALL'],
                            id: 1,
                            action: 'rejectFromAll'	
            		}
            		sortOptions.push(sortOption);
            	}
            };
            
            addActionConfigOptions($scope.actionListConfig.sortOptions);
            
            //watch dropdown selection
            $scope.$watch('actionListConfig.selectedOption', function(newValue, oldValue) {
                    if (angular.isDefined(newValue) && newValue != -1) {
                        triggerAction($scope.actionListConfig.sortOptions[newValue].action);
                        $scope.actionListConfig.selectedOption  = -1;
                    }
            });
            
            //trigger dropdownaction
            var triggerAction = function(action){
                    switch(action){
                        case 'addToReq':
                        addToRequisition();
                        break;

                        case 'rejectFromAll':
                        rejectFromAllApplications();
                        break;
                    }
            };

            //flag to hold checkbox selection
            $scope.grid = {
                selectAll : false
            };


            //reset all click handler
            $scope.resetAll = function(){
                $scope.search = {
                    keyword: '',
                    nameOnlySearch: true
                };
                $scope.defaultValue = 'Search Candidates';
                $scope.currentPage = 0;
                $scope.getCandidates($scope.currentPage);
                $scope.searchTypes.selectedOption = 1;
            };

            //watch selectall checkbox to toggle all rows
            $scope.$watch('grid.selectAll',function(newVal,oldVal){
                if(newVal){
                    //toggle all rows if select all checkbox selected
                    $scope.selectedCandidate = candidatesFactory.selectAllCandidates();
                }else{
                    //object to hold checkbox selection for each row
                    $scope.selectedCandidate = candidatesFactory.resetselectedCandidate();
                }
            });

            //build candidate search filter
            var getCandidateSearchFilter = function(){
                var filter = {
                    'page':$scope.currentPage,
                    'keywords': $scope.search.keyword,
                    'filterId':  $scope.GUID,
                    'nameOnlySearch': $scope.search.nameOnlySearch
                };
                return filter;
            };

            $scope.searchCandidates = function(){
            //dont send GUID wheen user does a new search
                delete $scope.GUID;
                $scope.getCandidates($scope.currentPage);
            };
            //create candidate factory instance
            var candidatesFactory = new jvCandidatesListFactory();

            //callbaks to fire after candidate List data is updated/fetched
            var updateTotalCount = function(){
                $scope.totalCount = candidatesFactory.totalCount;
            };
            var updateGUID = function(){
                $scope.GUID = candidatesFactory.GUID;
            };
            var updateCandidatesMap = function(){
                $scope.candidatesMap = candidatesFactory.candidatesMap;
            };

            var resetSelectAll = function(){
                $scope.selectedCandidate = candidatesFactory.resetselectedCandidate();
            };

            var getPageSize = function(){
                $scope.pageSize = candidatesFactory.getPageSize();
            };

            //register subscribers/callbacks to fire after candidatelist gets updates
            candidatesFactory.registerCandidatesSubscribers([updateTotalCount,updateGUID,updateCandidatesMap,resetSelectAll,getPageSize]);

            //call for candidates
            $scope.getCandidates = function(pageNumber){
                $scope.flags.loading = true;
                $scope.currentPage = pageNumber;
                var filters = getCandidateSearchFilter();
                candidatesFactory.getCandidates(filters).then(function(response){
                    $scope.flags.loading = false;
                    $scope.candidates = candidatesFactory.getCandidatesList();
                });
            };

            //make call to get candidates
            if($scope.properties.userHasRecruiterRole){
                $scope.getCandidates($scope.currentPage);
            }

            //invoke reject candidate modal
            var rejectFromAllApplications = function(){
                var data = {
                    appIds : [],
                    name: ''
                };
                data.appIds = candidatesFactory.getSelectedCandidates('latestApplicationEId');
                if(data.appIds.length){
                    data.name = candidatesFactory.getSelectedCandidates('fullName');
                    data.rejectAll = true;
                    $rootScope.$emit('showRejectCandidateModal',true, data);
                    $scope.noCandidateSelected = false;
                }else{
                    $scope.noCandidateSelected = true;
                }
            };

            //show notification for candidate rejection
            $rootScope.$on('rejectCandidateSuccess',function(event, onlyReset, multiple){
                if(!onlyReset){
                    $rootScope.$emit('showMessageBar', 'Candidate Rejected from all Applications');
                    $scope.getCandidates($scope.currentPage);
                }
            });

            //invoke add to requisition modal
            var addToRequisition = function(){
                var data = {
                    appIds: []
                };
                data.appIds = candidatesFactory.getSelectedCandidates('latestApplicationEId');
                if(data.appIds.length){
                    $rootScope.$emit('showAddToReqModal',data);
                    $scope.noCandidateSelected = false;
                }else{
                    $scope.noCandidateSelected = true;
                }
                
            };

            //show notification for candidate added to requisition
            $rootScope.$on('CandidateAddedToReq',function(event){
                $scope.$emit('showMessageBar', 'Candidate Added to Requisition');
                $scope.getCandidates($scope.currentPage);
            });

    }
]);
